
import CloseIcon from '@mui/icons-material/Close';
import CustomButton from '../../../component/elements/CustomButton/CustomButton';

function Alert({ onClose  ,dialogDetails}) {
      

    return (
        <div className="pt-6 px-10" >
            <div className="flex justify-between mb-6">
                <div className="flex justify-center w-full text-lg font-[500]" ></div>
                <button
                    className=" text-gray-600 hover:text-black"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <CloseIcon />
                </button>
            </div>
            <div className='flex flex-col my-4 w-full justify-center items-center' >
                <div className='font-[600] text-lg'>{dialogDetails}</div>
                <div className="flex justify-center items-center mt-8 mb-4 gap-3">
                    <CustomButton
                        onClick={() => onClose()}
                        customeClass={`gradient-button w-full sm:w-[150px] h-[40px]`}
                    >
                        Ok
                    </CustomButton>
                </div>
            </div>
        </div>
    );
}

export default Alert;